const collapsible_headers = document.querySelectorAll(".collapsible-header");
const onlyExpandOne = true;
let lastActiveCollapsibleBody = null;

function expand(el) {
  if (
    onlyExpandOne &&
    lastActiveCollapsibleBody
  ) {
    unexpand(lastActiveCollapsibleBody);
  }
  el.style.maxHeight = el.scrollHeight + "px";
  el.classList.add("active");
  lastActiveCollapsibleBody = el;
}

function unexpand(el) {
  el.style.maxHeight = null;
  el.classList.remove("active");
  el.parentElement.querySelector('.untoggled').style.display = 'block';
  el.parentElement.querySelector('.toggled').style.display = 'none';
}

collapsible_headers.forEach((collapsible) => {
  const collapsibleBody = collapsible.nextElementSibling;

  if (collapsibleBody.classList.contains("active")) {
    expand(collapsibleBody);
  }

  collapsible.addEventListener("click", function () {
    if (!!collapsibleBody.style.maxHeight) {
      unexpand(collapsibleBody);
      collapsible.querySelector('.untoggled').style.display = 'block';
      collapsible.querySelector('.toggled').style.display = 'none';
    } else {
      expand(collapsibleBody);
      collapsible.querySelector('.untoggled').style.display = 'none';
      collapsible.querySelector('.toggled').style.display = 'block';
    }
  });
});
